export const blueButton = {
  height: 40,
  background: '#1c487e',
  borderRadius: 5,
  borderStyle: 'none',
  color: '#ffffff',
  display: 'inline-block',
  fontSize: 14,
  fontWeight: 'bold',
  lineHeight: '14px',
  padding: '12px 20px 14px',
  textDecoration: 'none',
  textTransform: 'uppercase',
  cursor: 'pointer',

  $nest: {
    '&:hover': {
      textDecoration: 'underline',
      background: '#1c487e',
      color: '#ffffff !important'
    }
  }
};

export const moreButton = {
  display: 'inline-block',
  border: '1px solid rgb(28, 72, 126)',
  borderRadius: 5,
  textAlign: 'center',
  padding: '6px 20px 7px',
  color: '#21528d',
  fontSize: 14,
  lineHeight: '19px',
  fontWeight: 600,
  textDecoration: 'none',

  $nest: {
    '&:hover': {
      color: '#333333',
      textDecoration: 'underline'
    }
  }
};

export const nextButton = moreButton;

const lightGray = {
  display: 'inline-block',
  background: '#cdcdcd',
  border: '1px solid #cdcdcd',
  borderRadius: 5,
  textAlign: 'center',
  padding: '6px 20px 7px',
  color: '#ffffff',
  fontSize: 14,
  lineHeight: '19px',
  fontWeight: 600,
  textDecoration: 'none',

  $nest: {
    '&:hover': {
      textDecoration: 'underline'
    }
  }
};

export const lightGrayButton = {
  ...lightGray,
  $nest: {
    '&:hover': lightGray
  }
};

export const linkButton = {
  background: 'transparent',
  color: '#465056',
  padding: 0,
  margin: 0,
  display: 'inline-block',
  textDecoration: 'underline',
  textTransform: 'none',
  fontSize: 14,
  lineHeight: '22px',
  height: 'auto'
};
